import { render, staticRenderFns } from "./dialog-colorpicker.vue?vue&type=template&id=96cdd4c2&"
import script from "./dialog-colorpicker.vue?vue&type=script&lang=js&"
export * from "./dialog-colorpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports